import { useState, useEffect } from "react";
import "./ResponseContentSection.css";
import { Question } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../redux/features/appData";
import { ResponseNavigate } from "./ResponseNavigate";
import { SectionResponse } from "../config/responseSettings";
import config from "environment";
import { ResponseErrors } from "./responseErrors";
import { SectionSettings } from "../config/questionSettings";
import { NEXT_BUTTON } from "./ResponseContent";
import { TriangleAlert } from "lucide-react";

const debugMode = config.debugMode;

type ResponseContentSectionProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentSection = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentSectionProps) => {

    // const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [fontSize, setFontSize] = useState<number>(16);

    useEffect(() => {
        document.addEventListener("keydown", eventKeyDown);
        return () => {
            document.removeEventListener("keydown", eventKeyDown);
        }
    }, [])

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
        setError(ResponseErrors.none);
        
        const settings = JSON.parse(question.settings || "{}") as SectionSettings;

        if (settings.fontSize) {
            setFontSize(settings.fontSize);
        }

    }, [question, responseValues])

    const eventKeyDown = (event: KeyboardEvent) => {
        if (event.key === "Enter") {
            handleSubmit();
        }
    }

    const metRequirements = () => {
        return true;
    }

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {

        if (!metRequirements()) {
            setError("This field is required");
            return;
        }

        const newResponseValues: string = JSON.stringify({} as SectionResponse);

        console.log("[ResponseContentSection] newResponseValues: ", newResponseValues);

        onSubmit(newResponseValues);
    }
    
    const requirementsMet = metRequirements();
    // console.log("[ResponseContentSection] question: ", question);
    // console.log("[ResponseContentSection] values: ", responseValues);
    // console.log("[ResponseContentSection] text: ", text);


    return (
        <div className="form-content-body">

            {/* {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            } */}
                        
            <div 
                className="response-content-section"
                data-testid={"response-content-title:" + title}
            >
                <div 
                    className="response-content-section-title"
                    // style={{fontSize}}
                >
                    <span style={{fontSize}}>{title}</span>
                </div>
                {description &&
                    <div className="response-content-section-subtitle">
                        {description}
                    </div>
                }
               
            </div>

            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            {/* <div className="response-content-submit" style={{justifyContent: "center"}}>
                <button
                    className="response-content-button-submit"
                    onClick={handleSubmit}
                    data-testid="response-content-submit"
                >
                    {onNext ? NEXT_BUTTON : "Submit"}
                </button>
            </div> */}

            <ResponseNavigate 
                center={true}
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                buttonText="Continue"
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />

        </div>
    )
}